import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "row q-col-gutter-y-md" }
const _hoisted_3 = { class: "col-12 col-sm-4" }
const _hoisted_4 = { class: "text-h5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Total Posts", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12 col-sm-4"
}
const _hoisted_7 = { class: "text-h5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Pre Date of Loss", -1)
const _hoisted_9 = {
  key: 1,
  class: "col-12 col-sm-4"
}
const _hoisted_10 = { class: "text-h5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Post Date of Loss", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_loader = _resolveComponent("client-loader")!
  const _component_post_count = _resolveComponent("post-count")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_client_loader, {
      "client-id": _ctx.account.clientId,
      modelValue: _ctx.client,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event))
    }, null, 8, ["client-id", "modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_post_count, {
            filters: { accountIds: [this.account.id]}
          }, null, 8, ["filters"])
        ]),
        _hoisted_5
      ]),
      (_ctx.until)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_post_count, {
                filters: { accountIds: [this.account.id], until: _ctx.until }
              }, null, 8, ["filters"])
            ]),
            _hoisted_8
          ]))
        : _createCommentVNode("", true),
      (_ctx.since)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_post_count, {
                filters: { accountIds: [this.account.id], since: _ctx.since }
              }, null, 8, ["filters"])
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}